import { createFileRoute, redirect } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { OtpVerifyPage } from '@/features/auth';
import { isJwtExpired } from '@/lib/auth/jwt';
import { refreshSessionFromCookie } from '@/lib/auth/session';
import { getSafeInternalRedirect } from '@/lib/router/navigation';
import { useAuthStore } from '@/stores/auth';

const verifySearchSchema = z.object({
  verification_id: z.string().optional(),
  phone: z.string().optional(),
  redirect: z.string().optional(),
});

export const Route = createFileRoute('/_public/login/verify')({
  validateSearch: zodValidator(verifySearchSchema),
  beforeLoad: async ({ search }) => {
    const accessToken = useAuthStore.getState().accessToken;

    if (accessToken && !isJwtExpired(accessToken)) {
      throw redirect({
        href: getSafeInternalRedirect(search.redirect) ?? '/dashboard',
        replace: true,
      });
    }

    const refreshedToken = await refreshSessionFromCookie();
    if (refreshedToken && !isJwtExpired(refreshedToken)) {
      throw redirect({
        href: getSafeInternalRedirect(search.redirect) ?? '/dashboard',
        replace: true,
      });
    }

    if (!search.verification_id) {
      throw redirect({
        to: '/login',
        search: {
          redirect: getSafeInternalRedirect(search.redirect),
        },
        replace: true,
      });
    }
  },
  component: LoginVerifyRouteComponent,
});

function LoginVerifyRouteComponent() {
  const search = Route.useSearch();

  return (
    <OtpVerifyPage
      verificationId={search.verification_id}
      phone={search.phone}
      redirect={search.redirect}
    />
  );
}
